var exports = {
  "kL": "AddFriendSheet.module__container___NmdiS2",
  "XG": "AddFriendSheet.module__scroller___NmdiS2",
  "Qs": "AddFriendSheet.module__content___NmdiS2",
  "Y4": "AddFriendSheet.module__requestsSection___NmdiS2",
  "Ic": "AddFriendSheet.module__requestsGroup___NmdiS2",
  "sg": "AddFriendSheet.module__requestsHeader___NmdiS2",
  "vA": "AddFriendSheet.module__requestsList___NmdiS2",
  "Jt": "AddFriendSheet.module__requestDivider___NmdiS2",
};

module.exports = exports;
